module.exports = __webpack_public_path__ + "media/images/phi_banner-e5d539fef8d4954d7bcf67099de867a8.jpg";